import React, { useState, useEffect, useCallback } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { faEquals, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal, Button } from 'react-bootstrap'; // Importando componentes do React Bootstrap para o Modal
import { InputMask } from '@react-input/mask';
import { MaskedInput } from '../InputText/MaskedInput';
import BuscarProdutoModal from './Modal/BuscarProdutoModal';
import VencimentosModal from './Modal/VencimentosModal';

const FrenteDeCaixa: React.FC = () => {
  const [quantidade, setQuantidade] = useState<number>(1);
  const [precoUnitario, setPrecoUnitario] = useState<number>(0);
  const [totalVenda, setTotalVenda] = useState<number>(0);
  const [isNovaVenda, setIsNovaVenda] = useState<boolean>(false);

  const [showCancelModal, setShowCancelModal] = useState<boolean>(false); // Controle de estado do modal
  const [showQtdModal, setShowQtdModal] = useState<boolean>(false);
  const [showCpfModal, setShowCpfModal] = useState(false);
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [showVencimentosModal, setShowVencimentosModal] = useState(false);


  const [novaQuantidade, setNovaQuantidade] = useState<number>(1);
  const [tipoDocumento, setTipoDocumento] = useState<'cpf' | 'cnpj'>('cpf');
  const [cpfCnpj, setCpfCnpj] = useState('');


  useEffect(() => {
    setTotalVenda(quantidade * precoUnitario);
  }, [quantidade, precoUnitario]);

  const handleNovaVenda = () => {
    setIsNovaVenda(true);
    setQuantidade(1);
    setPrecoUnitario(0);
  };

  const handleConfirmarCancelamento = () => {
    // Limpar todos os inputs ao cancelar
    setQuantidade(0);
    setPrecoUnitario(0);
    setTotalVenda(0);
    setIsNovaVenda(false); // Desabilitar os campos
    setShowCancelModal(false); // Fechar o modal
  };

  const handleAbrirModalQtd = () => {
    setNovaQuantidade(quantidade);
    setShowQtdModal(true);
  };

  const handleConfirmarQtd = () => {
    setQuantidade(novaQuantidade);
    setShowQtdModal(false);
  };

  const handleCpfCnpjChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const cleanValue = value.replace(/\D/g, "");

    // Atualiza o estado com o valor formatado
    setCpfCnpj(value);

    // Se quiser armazenar o valor limpo em outro estado, adicione:
    // setCpfCnpjRaw(cleanValue); // ← só se quiser o valor sem máscara

    // Se estiver usando validação:
  }, []);


  return (
    <div className="container-fluid">
      <div className="card shadow-sm" style={{ minHeight: '720px', overflow: 'hidden' }}>
        <div className="card-body">
          <div className="row">
            {/* Botões laterais */}
            <div className="col-lg-2 col-md-4 p-0">
              <div className="d-grid gap-2">
                {[
                  { label: 'Nova venda', onClick: handleNovaVenda, icon: 'fa-solid fa-cash-register' },
                  { label: 'Finalizar venda', icon: 'fa-solid fa-circle-check', onClick: () => setShowVencimentosModal(true) },
                  { label: 'Alterar quantidade', onClick: handleAbrirModalQtd, icon: 'fa-solid fa-plus-minus' },
                  { label: 'Informar CPF/CNPJ', onClick: () => setShowCpfModal(true), icon: 'fa-solid fa-id-card' },
                  { label: 'Desconto', icon: 'fa-solid fa-percent' },
                  { label: 'Procurar produto', icon: 'fa-solid fa-magnifying-glass', onClick: () => setShowSearchModal(true) },
                  { label: 'Excluir item', icon: 'fa-solid fa-file-circle-xmark' },
                  { label: 'Cancelar venda', onClick: () => setShowCancelModal(true), icon: 'fa-solid fa-circle-xmark' },
                  { label: 'Incluir diversos', icon: 'fa-solid fa-triangle-exclamation' },
                ].map(({ label, onClick, icon }, idx) => (
                  <Button
                    key={idx}
                    variant="outline-secondary"
                    size="lg"
                    className="d-flex col-lg-12 col-md-12"
                    onClick={onClick}
                  >
                    <i className={`${icon} me-2 fs-5 pt-1`}></i>&nbsp;
                    {label}
                  </Button>
                ))}
              </div>
            </div>

            {/* Conteúdo principal */}
            <div className="col-lg-10 col-md-8">
              <form className="g-2 mb-3">

                <div className='row'>
                  <div className="col-lg-3 col-md-6">
                    <label className="form-label">Entrada de Dados</label>
                    <input type="text" className="form-control form-control-lg" disabled={!isNovaVenda}/>
                  </div>
                  <div className="col-lg-3 col-md-6">
                    <label className="form-label">Código do Produto</label>
                    <input type="text" className="form-control form-control-lg" disabled={!isNovaVenda}/>
                  </div>
                  <div className="col-lg-6 col-md-12">
                    <label className="form-label">Descrição do Produto</label>
                    <input type="text" className="form-control form-control-lg" disabled={!isNovaVenda}/>
                  </div>
                </div>

                <div className='row'>
                  <div className="col-lg-1 col-md-4">
                    <label className="form-label">Unidade</label>
                    <input type="text" className="form-control " disabled={!isNovaVenda}/>
                  </div>
                  <div className="col-lg-1 col-md-4">
                    <label className="form-label">Tamanho</label>
                    <input type="text" className="form-control " disabled={!isNovaVenda}/>
                  </div>
                  <div className="col-lg-2 col-md-4 ">
                    <label className="form-label">Lote</label>
                    <input type="text" className="form-control  " disabled={!isNovaVenda}/>
                  </div>
                  <div className="col-lg-2 col-md-3">
                    <label className="form-label">Quantidade</label>
                    <input
                        type="number"
                        className="form-control "
                        value={quantidade}
                        onChange={(e) => setQuantidade(parseFloat(e.target.value) || 0)}
                        disabled={!isNovaVenda}
                    />
                  </div>

                  <div className="
                    d-flex p-0 align-items-end justify-content-center  
                    col-lg-1 col-md-1 
                    mb-2 mb-lg-0 mb-md-0 mt-2 mt-lg-0 mt-md-0"
                  >
                    <FontAwesomeIcon icon={faXmark} size='2x'/>
                  </div>

                  <div className="col-lg-2 col-md-4">
                    <label className="form-label">Preço Unitário</label>
                    <input
                        type="number"
                        step="0.01"
                        className="form-control "
                        value={precoUnitario}
                        onChange={(e) => setPrecoUnitario(parseFloat(e.target.value) || 0)}
                        disabled={!isNovaVenda}
                    />
                  </div>

                  <div className="
                    d-flex align-items-end justify-content-center
                    col-lg-1 col-md-1 p-0 
                    mb-2 mb-lg-0 mb-md-0 mb-lg-0 mt-2 mt-lg-0 mt-md-0"
                  >
                    <FontAwesomeIcon icon={faEquals} size='2x'/>
                  </div>

                  <div className="col-lg-2 col-md-3 ">
                    <label className="form-label">Total do Item</label>
                    <input
                        type="text"
                        className="form-control "
                        value={totalVenda.toFixed(2)}
                        readOnly
                    />
                  </div>
                </div>
              </form>

              <div style={{maxHeight: '600px', overflowY: 'auto'}}>
                <table className="table table-bordered table-sm text-center align-middle">
                  {[...Array(3)].map((_, index) => (
                      <React.Fragment key={index}>
                        <thead className="table-light">
                        <tr>
                          <th>Nº item</th>
                          <th>Código do produto</th>
                          <th colSpan={2}>Descrição</th>
                          <th>Tamanho</th>
                          <th>Unidade</th>
                          <th>Lote</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                          <td><input type="text" className="form-control form-control-sm" value={index + 1} disabled/>
                          </td>
                          <td><input type="text" className="form-control form-control-sm" value={`P00${index + 1}`}
                                     disabled/></td>
                          <td colSpan={2}><input type="text" className="form-control form-control-sm"
                                                 value={`Produto de Exemplo ${index + 1}`} disabled/></td>
                          <td><input type="text" className="form-control form-control-sm"
                                     value={`${Math.floor(Math.random() * 100)}cm`} disabled/></td>
                          <td><input type="text" className="form-control form-control-sm" value="UN" disabled/></td>
                          <td><input type="text" className="form-control form-control-sm" value={`L${1000 + index}`}
                                     disabled/></td>
                        </tr>
                        </tbody>
                        <thead className="table-light">
                        <tr>
                          <th>Código de barras</th>
                          <th>Qtd</th>
                          <th>Preço unitário</th>
                          <th>Valor</th>
                          <th>Desc (%)</th>
                          <th>Desc (R$)</th>
                          <th>Total do item</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                          <td><input type="text" className="form-control form-control-sm" value={`7891234000${index}`} disabled/></td>
                          <td><input type="number" className="form-control form-control-sm" value={Math.floor(Math.random() * 10) + 1}
                                     disabled/></td>
                          <td><input type="number" className="form-control form-control-sm" value={(Math.random() * 50 + 10).toFixed(2)}
                                     disabled/></td>
                          <td><input type="text" className="form-control"
                                     value={`R$ ${(Math.random() * 200).toFixed(2)}`} disabled/></td>
                          <td><input type="number" className="form-control form-control-sm" value={(Math.random() * 10).toFixed(1)}
                                     disabled/></td>
                          <td><input type="number" className="form-control form-control-sm" value={(Math.random() * 20).toFixed(2)}
                                     disabled/></td>
                          <td><input type="text" className="form-control form-control-sm"
                                     value={`R$ ${(Math.random() * 500).toFixed(2)}`} disabled/></td>
                        </tr>
                        </tbody>
                      </React.Fragment>
                  ))}
                </table>
              </div>

            </div>
          </div>
        </div>

        {/* Total da venda dentro do body */}
        <div className="m-3 d-flex justify-content-end ">
          <div className="col-lg-2 col-md-2 ">
            <label className="form-label">Total da Venda</label>
            <input
                type="text"
                className="form-control form-control-lg text-end fw-bold"
                value={`R$ ${totalVenda.toFixed(2)}`}
                readOnly
            />
          </div>
        </div>

        {/* Footer com botão fechar */}
        <div className="card-footer d-flex justify-content-end">
          <button disabled={isNovaVenda} className="btn btn-secondary btn-sm">Fechar</button>
        </div>
      </div>

      {/* Modal de confirmação de cancelamento */}
      <Modal show={showCancelModal} onHide={() => setShowCancelModal(false)}>
        <Modal.Header closeButton style={{background: 'linear-gradient(#f8f9fa, #d6d8db)'}}>
          <Modal.Title>Cancelar Venda</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Tem certeza de que deseja cancelar a venda? Todos os dados serão perdidos.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowCancelModal(false)}>
            Fechar
          </Button>
          <Button variant="danger" onClick={handleConfirmarCancelamento}>
            Cancelar Venda
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal Alterar Quantidade */}
      <Modal show={showQtdModal} onHide={() => setShowQtdModal(false)}>
        <Modal.Header closeButton style={{background: 'linear-gradient(#f8f9fa, #d6d8db)'}}>
          <Modal.Title>Alterar Quantidade</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <input
              type="number"
              className="form-control"
              value={novaQuantidade}
              min={1}
              onChange={(e) => setNovaQuantidade(parseFloat(e.target.value) || 1)}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowQtdModal(false)}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleConfirmarQtd}>
            Confirmar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal CPF/CNPJ */}
      <Modal show={showCpfModal} onHide={() => setShowCpfModal(false)}>
        <Modal.Header closeButton style={{background: 'linear-gradient(#f8f9fa, #d6d8db)'}}>
          <Modal.Title>Informar CPF ou CNPJ</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <label className="form-label d-block">Tipo de Documento:</label>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="tipoDocumento"
                id="cpfOption"
                checked={tipoDocumento === 'cpf'}
                onChange={() => setTipoDocumento('cpf')}
              />
              <label className="form-check-label" htmlFor="cpfOption">
                CPF
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="tipoDocumento"
                id="cnpjOption"
                checked={tipoDocumento === 'cnpj'}
                onChange={() => setTipoDocumento('cnpj')}
              />
              <label className="form-check-label" htmlFor="cnpjOption">
                CNPJ
              </label>
            </div>
          </div>

          <MaskedInput
            id="cpfCnpj"
            value={cpfCnpj}
            onChange={handleCpfCnpjChange}
            mask={tipoDocumento === 'cnpj' ? '__.___.___/____-__' : '___.___.___-__'}
            placeholder={`Digite o ${tipoDocumento.toUpperCase()}`}
          />


        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowCpfModal(false)}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>

      <BuscarProdutoModal
        show={showSearchModal}
        onHide={() => setShowSearchModal(false)}
      />

      <VencimentosModal
        show={showVencimentosModal}
        onHide={() => setShowVencimentosModal(false)}
      />

    </div>
  );
};

export default FrenteDeCaixa;
